import { render, staticRenderFns } from "./formulariosComponent.vue?vue&type=template&id=69a34bf1"
import script from "./formulariosComponent.vue?vue&type=script&lang=js"
export * from "./formulariosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports